import { Flex, Paper, Text } from "@pillar-ui/core";
import { useState } from "react";
import { LUCKY_GAME_TAB } from "../common/constants";
import drinkingWheelImg from "../assets/icons/drinking-wheel.png";
import DrinkingWheel from "../components/drinking-wheel";
import { PlayCard } from "@pillar-ui/icons";

const LuckyGames = () => {
  const [tab, setTab] = useState("");

  return (
    <Flex direction="col" gap="5" items="center" style={{ paddingBottom: 100 }}>
      <Flex items="center" gap="2">
        <PlayCard width={30} height={30} />
        <Text
          size="9"
          color="p"
          style={{ paddingTop: 16, paddingBottom: 16, fontWeight: 700 }}
        >
          {"Trò Chơi May Mắn"}
        </Text>
        <PlayCard width={30} height={30} />
      </Flex>
      {!tab && (
        <Flex direction="col" items="center" gap="2">
          <Paper
            onClick={() => setTab(LUCKY_GAME_TAB.DRINKING)}
            corner="5"
            style={{ overflow: "hidden" }}
          >
            <img
              src={drinkingWheelImg}
              alt={drinkingWheelImg}
              style={{
                width: "calc(100vw - 70px)",
                maxWidth: 400,
                aspectRatio: 1.3,
                objectFit: "cover",
              }}
            />
          </Paper>
          <Text size="8" color="se">
            {"Vòng Quay Uống Rượu"}
          </Text>
        </Flex>
      )}
      {tab === LUCKY_GAME_TAB.DRINKING && <DrinkingWheel />}
    </Flex>
  );
};

export default LuckyGames;
